import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.jpeg';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isHeroPage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    setScrolled(window.scrollY > 50);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location]);

  useEffect(() => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/products', label: 'Products' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  const navClass = ['navbar', isHeroPage ? 'hero-page' : '', scrolled ? 'scrolled' : ''].filter(Boolean).join(' ');

  return (
    <>
      <nav className={navClass}>
        <div className="navbar-inner">
          <Link to="/" className="navbar-brand">
            <div className="navbar-logo-wrap">
              <img src={logo} alt="SSE Logo" className="navbar-logo" />
            </div>
            <div className="navbar-brand-text">
              <span className="brand-main">Sri Sai</span>
              <span className="brand-sub">Engineerings</span>
            </div>
          </Link>

          {/* Desktop links */}
          <div className="navbar-links-desktop">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact" className="nav-cta">Get Quote</Link>
          </div>

          <button
            className={`hamburger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(prev => !prev)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile menu — completely separate from navbar, rendered at root level */}
      <div className={`mobile-menu-overlay ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)} />
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <div className="mobile-menu-brand">
            <img src={logo} alt="SSE" className="mm-logo" />
            <div>
              <div className="mm-brand-name">Sri Sai Engineerings</div>
              <div className="mm-brand-tag">World of Rice Mill Machinery</div>
            </div>
          </div>
          <button className="mm-close" onClick={() => setMenuOpen(false)} aria-label="Close">
            <span /><span />
          </button>
        </div>

        <nav className="mobile-nav">
          {navLinks.map((link, i) => (
            <Link
              key={link.to}
              to={link.to}
              className={`mm-link ${location.pathname === link.to ? 'active' : ''}`}
              style={{ animationDelay: `${i * 0.06}s` }}
              onClick={() => setMenuOpen(false)}
            >
              <span className="mm-link-num">0{i + 1}</span>
              <span className="mm-link-label">{link.label}</span>
              <span className="mm-link-arrow">→</span>
            </Link>
          ))}
        </nav>

        <div className="mobile-menu-footer">
          <Link to="/contact" className="mm-cta" onClick={() => setMenuOpen(false)}>
            Get a Free Quote
          </Link>
          <div className="mm-contact-info">
            <a href="tel:+919848027990">📞 9848027990</a>
            <a href="mailto:srisaiengs@gmail.com">✉️ srisaiengs@gmail.com</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar; 